export default __webpack_public_path__ + "static/media/book-manual.0549ed45.svg";